// extracted by mini-css-extract-plugin
module.exports = {"login":"MitIDOnly_login__tN_kH","title":"MitIDOnly_title__9G50w","text":"MitIDOnly_text__wqPgP"};